import { IconProp } from "@fortawesome/fontawesome-svg-core"
import { IconDefinition } from "@fortawesome/pro-solid-svg-icons"
import { ChipPropsColorOverrides } from "@mui/material"
import { OverridableStringUnion } from "@mui/types"
import { Row } from "@tanstack/react-table"
import { IFormResult } from "components/Form/FormTemplate/formtemplate.interface"
import { ChipInfoStatusEnum } from "components/Status/ChipInfo/chipInfo.interface"

export interface TemplateSettings {
  label?: string
  icon: IconProp
  title: string
  description?: string
  defaultValue?: string
}

export interface IDeviationProps {
  name: string
  assignedUserId: number
  assignedUser: string
  createdTime: string
  createdById: number
  formResult: IFormResult
  id: number
  priority: number
  status: number
  involvedUserId: number
  updatedTime: string
  updatedById: number
  feature: string
}

export interface IDeviationStatusProps {
  icon: IconDefinition
  key: string
  title: string
  description?: string
  color: OverridableStringUnion<
    "default" | "primary" | "secondary" | "error" | "info" | "success" | "warning",
    ChipPropsColorOverrides
  >
}
export interface IDeviationPriorityProps {
  title: string
  key: string
  color: OverridableStringUnion<
    "default" | "primary" | "secondary" | "error" | "info" | "success" | "warning",
    ChipPropsColorOverrides
  >
}

export enum StatusDeviationEnum {
  New = 0,
  Assigned = 1,
  Completed = 2,
  OnGoing = 4
}

export const deviationChip = (type: StatusDeviationEnum): ChipInfoStatusEnum => {
  switch (type) {
    case StatusDeviationEnum.New:
      return ChipInfoStatusEnum.New
    case StatusDeviationEnum.Assigned:
      return ChipInfoStatusEnum.Assigned
    case StatusDeviationEnum.Completed:
      return ChipInfoStatusEnum.Completed
    case StatusDeviationEnum.OnGoing:
      return ChipInfoStatusEnum.OnGoing
    default:
      return ChipInfoStatusEnum.Unmanaged
  }
}

export interface Deviation {
  assignedUser: any | null
  assignedUserId: number | null
  createdByName: string
  createdTime: string
  customerDeviationId: number
  customerId: number
  id: number
  name: string
  priority: number
  status: number
  updatedByName: string | null
  updatedTime: string | null
}

export interface DeviationAttributes {
  id: number
  priority: number
}

export interface DeviationTableFilterOptions {
  assignedUserOptions: string[]
  deviationType: string[]
}

export interface DeviationTableProps {
  api: any
  columns: any
  tableId: any
  refreshKey: number
  onRowClick?: (row: Row<any>) => void;
}
